var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0938 1.5625H3.90625C3.28465 1.5625 2.68851 1.80943 2.24897 2.24897C1.80943 2.68851 1.5625 3.28465 1.5625 3.90625L1.5625 21.0938C1.5625 21.7154 1.80943 22.3115 2.24897 22.751C2.68851 23.1906 3.28465 23.4375 3.90625 23.4375H10.6079V16.0005H7.53174V12.5H10.6079V9.83203C10.6079 6.79736 12.4146 5.12109 15.1816 5.12109C16.5068 5.12109 17.8926 5.35742 17.8926 5.35742V8.33594H16.3657C14.8613 8.33594 14.3921 9.26953 14.3921 10.2271V12.5H17.7505L17.2134 16.0005H14.3921V23.4375H21.0938C21.7154 23.4375 22.3115 23.1906 22.751 22.751C23.1906 22.3115 23.4375 21.7154 23.4375 21.0938V3.90625C23.4375 3.28465 23.1906 2.68851 22.751 2.24897C22.3115 1.80943 21.7154 1.5625 21.0938 1.5625Z",
    fill: "#0F8A38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSquare);
export default __webpack_public_path__ + "static/media/facebook-square.3960cca382be61888ae3ab0fb61b1d48.svg";
export { ForwardRef as ReactComponent };